import { FileTextOutlined } from "@ant-design/icons";
import { Space, Row, Form, Select, DatePicker } from "antd";
import { Fragment } from "react";
import ResponsiveCol from "common/components/form/ResponsiveCol";
import locale from "antd/es/date-picker/locale/es_ES";
import dayjs from "dayjs";
import { UPLOAD_KIND } from "hooks/historicalData/useHistoricalData";

interface HistoricalDataUploadConfigurationsProps {
  setKindSelected: React.Dispatch<React.SetStateAction<UPLOAD_KIND>>;
  setSelectedMonth: (date: dayjs.Dayjs | null) => void;
  rangeTimeValue: [dayjs.Dayjs, dayjs.Dayjs];
}

function HistoricalDataUploadConfigurations({
  setKindSelected,
  rangeTimeValue,
  setSelectedMonth,
}: HistoricalDataUploadConfigurationsProps) {
  return (
    <Fragment>
      <Space>
        <FileTextOutlined />
        Configuración de Carga
      </Space>
      <p style={{ fontSize: "12px" }}>
        Selecciona el tipo de punto de distribución y el periodo a validar antes
        de cargar archivos
      </p>

      <Row gutter={24}>
        <ResponsiveCol size="lg">
          <Form.Item label="Tipo de Punto de Distribución">
            <Select
              defaultValue={UPLOAD_KIND.PLANTAS}
              style={{ width: "100%" }}
              onChange={setKindSelected}
            >
              <Select.Option key={0} value={UPLOAD_KIND.PLANTAS}>
                Plantas
              </Select.Option>
              <Select.Option key={1} value={UPLOAD_KIND.ESTACIONES}>
                Estaciones
              </Select.Option>
            </Select>
          </Form.Item>
        </ResponsiveCol>
        <ResponsiveCol size="lg">
          <Form.Item label="Periodo de Validación">
            <DatePicker
              picker="month"
              style={{ width: "100%" }}
              locale={locale}
              value={rangeTimeValue[0]}
              format="MMMM YYYY"
              onChange={setSelectedMonth}
            />
          </Form.Item>
        </ResponsiveCol>
      </Row>
    </Fragment>
  );
}
export default HistoricalDataUploadConfigurations;
